module.exports = node_modulesvuedistvueminjs;